import React, { Component } from 'react'
import { object } from 'prop-types'
import { connect } from 'react-redux'
import { Popup } from 'react-mapbox-gl'
import SamePointSigns from './SamePointSigns'
import { updateInfobox } from '../../../store/Actions/MapActions'
import '../styles/popup.css'

class SameSupportInfoBox extends Component {
  render() {
    return this.props.infobox.coordinates !== null &&
      this.props.infobox.type === 'sameSupport' ? (
      <Popup
        className="popup-container"
        coordinates={this.props.infobox.coordinates}
        offset={{
          'bottom-left': [12, -38],
          bottom: [0, -70],
          'bottom-right': [-12, -38],
        }}
      >
        <div
          className="marker-popup"
          onMouseLeave={() =>
            this.props.updateInfobox({
              coordinates: null,
              signs: null,
              sign: null,
              type: null,
            })
          }
        >
          <SamePointSigns
            signs={this.props.infobox.signs}
            message={`There are ${
              this.props.infobox.signs.length
            } signs on same support`}
          />
        </div>
      </Popup>
    ) : null
  }
}

SameSupportInfoBox.propTypes = {
  infobox: object.isRequired,
}

const mapStateToProps = ({ map }) => ({
  infobox: map.infobox,
})

const mapDispatchToProps = dispatch => ({
  updateInfobox: value => dispatch(updateInfobox(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SameSupportInfoBox)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/SameSupportInfoBox.jsx